<template name="ec_info">
  <div class="about">
    <div class="banner">
      <div class="banner-warpper">
        <div class="container">
          <div class="banner-text">
            <h2>关于我们</h2>
            <span class="subtitle"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="about_main">
      <div class="container" v-html="ec?ec.desc:''"></div>
      <div class="container">
        <div class="row">
          <div class="col-lg-6">
            <h2>联系我们</h2>
            <div class="my_heng">
              <div class="my_hengxian"></div>
            </div>
            <p style="margin: 10px 0;">地址：{{ec?ec.address:''}}</p>
            <p style="margin: 10px 0;">电话：{{ec?ec.linkphone:''}}</p>
            <p style="margin: 10px 0;">邮箱：{{ec?ec.email:''}}</p>
          </div>
          <div class="col-lg-6">
            <div class="my_beijing map">
              <iframe
                v-if="ecdata"
                :src="'/map.html?'+ecdata"
                width="570"
                height="380"
                frameborder="0"
                scrolling="no"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "underscore";
export default {
  data() {
    return {
      ec: null,
    };
  },
  computed: {
    ecdata() {
      if (this.ec)
        return encodeURIComponent(
          JSON.stringify(
            _.pick(this.ec, [
              "name",
              "address",
              "location",
              "linkphone",
              "email",
            ])
          )
        );
      return false;
    },
  },
  methods: {
    getdata() {
      this.$api
        .post("/wapi", {
          method: "ssy-app/ec/info",
          data: {},
        })
        .then((res) => {
          if (res.code !== 0) return;
          this.ec = res.data.ec;
        })
        .catch((err) => {});
    },
  },
  mounted() {
    this.getdata();
  },
};
</script>